// Language actions
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_LOADING_LANGUAGE = 'SET_LOADING_LANGUAGE';
export const SET_AVAILABLE_LANGUAGES = 'SET_AVAILABLE_LANGUAGES';
export const RESET_LANGUAGE = 'RESET_LANGUAGE';

export function setLanguage(language: string) {
  return {
    type: SET_LANGUAGE,
    payload: language,
  };
}

export function setLoadingLanguage(isLoading: boolean) {
  return {
    type: SET_LOADING_LANGUAGE,
    payload: isLoading,
  };
}

export function setAvailableLanguages(languages: string[]) {
  return {
    type: SET_AVAILABLE_LANGUAGES,
    payload: languages,
  };
}

export function resetLanguage() {
  return {
    type: RESET_LANGUAGE,
  };
}
